export const WIDGET_UP = 'widgetList/UP';
export const WIDGET_DOWN = 'widgetList/DOWN';
export const WIDGET_GET = 'widgetList/GET';
export const WIDGET_ERROR = 'widgetList/ERROR';
export const WIDGET_UPDATE = 'widgetList/UPDATE';
